import {useState, useEffect} from "preact/compat";

export const useFourthStep = (props) => {
    // Destructured props
    const {
        handleStepChange,
        handlePayloadUpdate,
        surveyData
    } = props;

    // State to store all form values
    const [formValues, setFormValues] = useState({
        option: "",
        additionalComment: ""
    });
    // Flags that the remaining options should be disabled when the positive option is selected
    const [shouldDisableOptions, setShouldDisableOptions] = useState(false);

    // Procedure to handle all input value changes
    const handleChange = (e) => {
        // Destructured event props
        const {
            name,
            value
        } = e.target;

        // Assigns the new values to the formState data object
        setFormValues(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        })

        // Happy ending
        if (name === "option" && value !== "others") {
            // Disable all options
            setShouldDisableOptions(true);
        }
    }

    // Procedure to handle the form submission
    const handleSubmit = (
        e = undefined
    ) => {
        if (e) {
            // Prevents page from reloading
            e.preventDefault();
        }

        // Synchronizes the payload state with the current step's form values
        handlePayloadUpdate({
            data: {
                question_text: "Como você ficou sabendo da Loja Virtual do Sabin?",
                question_type: "advanced",
                option: surveyData.options.find(item => {
                    let parsedOption =
                        formValues.option === "others" ?
                            formValues.option :
                            parseInt(formValues.option, 10);

                    return item.id === parsedOption;
                }).label,
                input: formValues.additionalComment,
            }
        });

        // Proceeds to the next step
        handleStepChange({
            action: "NEXT"
        });
    }

    // Effect to lock all the options and submit the form after a one-second delay
    useEffect(() => {
        if (!shouldDisableOptions) {
            return;
        }

        // Submits the form after a one-second delay
        const timer = setTimeout(() => {
            handleSubmit();

            clearTimeout(timer);
        }, 1000);
    }, [shouldDisableOptions]);

    return {
        formValues,
        shouldDisableOptions,
        handleChange,
        handleSubmit
    }
}
